import {memo, useState} from 'react'

import PropTypes from 'prop-types'

import {useSuiContext} from '@s-ui/react-context'
import {useNearScreen} from '@s-ui/react-hooks'
import {CardRelatedAdV2} from '@adv-mt/mt-card-related-ad'
import SharedCardsCarousel from '@adv-mt/mt-shared-cards-carousel'
import {Headline1} from '@adv-mt/ui/typography'

import TrackingListRelatedAds from '../../components/TrackingListRelatedAds.js'
import {BASE_CLASS as PAGE_BASE_CLASS} from '../../config.js'
import useRecommendationWidgetViewed from '../../hooks/useRecommendationWidgetViewed.js'

const BASE_CLASS = `${PAGE_BASE_CLASS}-relatedAds`
const CAROUSEL_TYPE = 'carrousel listado coches anuncios recomendados'
const MAX_ITEMS = 10

const RelatedAds = ({relatedAds = []}) => {
  const {domain, i18n} = useSuiContext()
  const [isNear, outerRef] = useNearScreen()
  const [products, setProducts] = useState()

  const config = domain.get('config')
  const {ADS_DETAIL_PAGE_TYPE, TRACKING_TRANSLATIONS_BY_CULTURE} = config.get('tracking')
  const {ADS_DETAIL_PAGE_NAME: pageNameOrigin, AD_DETAIL_RELATED_ADS_LIST_TYPE: listTypeRelatedAds} =
    TRACKING_TRANSLATIONS_BY_CULTURE[i18n.culture]

  useRecommendationWidgetViewed({carouselType: CAROUSEL_TYPE, hasAds: Boolean(relatedAds.length)})

  if (!relatedAds.length) {
    return null
  }

  return (
    <section className={BASE_CLASS} ref={outerRef}>
      {isNear && (
        <TrackingListRelatedAds ads={relatedAds} listType={listTypeRelatedAds} onProductsReceived={setProducts} />
      )}
      <SharedCardsCarousel titleNode={<Headline1 as="h2">{i18n.t('COMMON.SIMILAR_ADS')}</Headline1>}>
        {relatedAds.slice(0, MAX_ITEMS).map((ad, index) => (
          <CardRelatedAdV2
            ad={ad}
            extendedTrackingData={products}
            key={ad.id}
            listType={listTypeRelatedAds}
            pageNameOrigin={pageNameOrigin}
            pageType={ADS_DETAIL_PAGE_TYPE}
            position={index}
          />
        ))}
      </SharedCardsCarousel>
    </section>
  )
}

RelatedAds.displayName = 'RelatedAds'

RelatedAds.propTypes = {
  relatedAds: PropTypes.array
}

export default memo(RelatedAds)
